import { createStackNavigator } from '@react-navigation/stack'
import { Header } from '../comps/Header'
import { EnterAadhaarCardScreen } from '../screens/EnterAadhaarCardScreen'
import { EnterAadhaarOTPScreen } from '../screens/EnterAadhaarOTPScreen'
import { LoadInitialsScreen } from '../screens/LoadInitialsScreen'
import { ScanFingerprintScreen } from '../screens/ScanFingerprintScreen'
import { Screens } from './Screens'

export const AuthStack = () => {
  const Stack = createStackNavigator()
  return (
    <Stack.Navigator
      screenOptions={{
        headerTitle: 'AePS Services',
        header: Header,
        cardStyle: { flex: 1 },
      }}>
      <Stack.Screen name={Screens.LOAD_INITIALS} component={LoadInitialsScreen} />
      <Stack.Screen name={Screens.ENTER_AADHAAR_CARD} component={EnterAadhaarCardScreen} />
      <Stack.Screen name={Screens.ENTER_AADHAAR_OTP} component={EnterAadhaarOTPScreen} />
      <Stack.Screen name={Screens.SCAN_FINGERPRINT} component={ScanFingerprintScreen} />
    </Stack.Navigator>
  )
}
